import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoaderContainer, WrapLoader } from "./styled";
export const Loader = ({ ...props }) => (_jsxs(LoaderContainer, { ...props, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
export { WrapLoader };
